<template>
    <rkm-area
        :subtitle="subtitle"
        title="Avaliação antropométrica"
    >
        <Form
            :data="data"
            ref="Form"
        />
    </rkm-area>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    computed: {
        subtitle() {
            if (this.data.form.avaliacaoAntropometrica) {
                return this.data.form.avaliacaoAntropometrica.dataHora.concat(
                    ' | ',
                    this.data.form.avaliacaoAntropometrica.lotacao.profissional.nome
                )
            } else {
                return ''
            }
        }
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>